import type { UpdateLocationResponseDto } from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { usersApi } from './sdk-client';

export type UpdateLocationInput = {
  latitude: number;
  longitude: number;
};

export type UpdateLocationResult = {
  timezoneId: string;
  iana: string;
  displayName: string;
  offsetLabel: string;
  autoTimezoneEnabled: boolean;
};

export class LocationError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'LocationError');
  }
}

export async function updateUserLocation(
  input: UpdateLocationInput,
): Promise<UpdateLocationResult> {
  const data = await executeSdkRawRequest<UpdateLocationResponseDto>({
    request: () =>
      usersApi.locationControllerUpdateV1Raw({
        updateLocationDto: {
          latitude: input.latitude,
          longitude: input.longitude,
        },
      }),
    fallback: 'Failed to update location',
    ErrorClass: LocationError,
  });

  return {
    timezoneId: data.timezoneId,
    iana: data.iana,
    displayName: data.displayName,
    offsetLabel: data.offsetLabel,
    autoTimezoneEnabled: data.autoTimezoneEnabled,
  };
}
